/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Menu } from '@neo4j-ndl/react';
import {
  AppearanceIcon,
  CheckCircleIconSolid,
  DatabaseSignalIcon,
} from '@neo4j-ndl/react/icons';
import { TreeView } from '@neo4j-ndl/react/next';
import { useState } from 'react';

const Component = () => {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <TreeView ariaLabel="Databases">
      <TreeView.Item
        title="Production"
        isSelected={selected === 'production'}
        onSelectedChange={() => setSelected('production')}
        leadingVisual={<DatabaseSignalIcon />}
        trailingContent={
          <CheckCircleIconSolid className="n-size-5 n-text-success-bg-status" />
        }
        actionMenuItems={
          <>
            <Menu.Item title="Edit" />
            <Menu.Item title="Delete" />
            <Menu.Item title="Rename" />
          </>
        }
      />
      <TreeView.Item
        title="Development"
        isSelected={selected === 'development'}
        onSelectedChange={() => setSelected('development')}
        leadingVisual={<DatabaseSignalIcon />}
        trailingContent={
          <AppearanceIcon className="n-size-5 n-text-warning-bg-status" />
        }
      />
    </TreeView>
  );
};

export default Component;
